// Content as of this page load: what the admin panel saved after the last
// build (injected by functions/_middleware.ts), otherwise the bundled JSON.
import bundledUnits from "./units.json";
import bundledTesti from "./testi.json";

const injected = (() => {
  try {
    const el = typeof document !== "undefined" && document.getElementById("pp-content");
    return el ? JSON.parse(el.textContent) : {};
  } catch {
    return {};
  }
})();

export const units = injected.units || bundledUnits;
export const testi = injected.testi || bundledTesti;
